import UserProfileContent from './UserProfileContent'

export default UserProfileContent
